import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MCause } from "../../models/cause.model";
import { MUser } from "../../models/user.model";
import { MActionPlan } from "../../models/MActionPlan";
import { isUndefined } from "util";
import { TranslateService } from "@ngx-translate/core";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { GlobalsService } from "src/app/shared/services/globals";
import { saveAs } from "file-saver";
@Component({
  selector: "FormTratment",
  templateUrl: "./form-tratment.component.html",
  styleUrls: ["./form-tratment.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTratmentComponent implements OnInit {
  @Input() public gncId: string;
  @Input() public index: number;
  @Input() public title_number: number;
  @Input() public causes: any[];
  @Input() public users: MUser[];
  @Input() public action: any;
  @Input() public readOnly: boolean;
  @Input() public inExecution: boolean;
  @Input() public inVerify: boolean;
  @Input() public inSummary: boolean;
  @Input() public defaultUserVerify: any = null;
  @Input() public defaultUserExecute: any = null;
  @Output() public changeInputs: EventEmitter<string> = new EventEmitter();
  @Output() public deleteActionPlan: EventEmitter<string> = new EventEmitter();
  @Output() public deleteCause: EventEmitter<string> = new EventEmitter();
  @Output() public addCause: EventEmitter<string> = new EventEmitter();
  @ViewChild("area") public area: any;
  // , { static: true }
  tagUsers: any[] = [];
  tagUsersExecute: any[] = [];
  tagUsersEvaluates: any[] = [];
  evidenciasNC: any = [];
  evidenciasAccion: any = [];
  causesAux: any[] = [];
  update = false;
  change = true;
  openPanel: boolean = true;
  planTitle: string;

  datepickerConfig: any;
  minDate: any;
  actionForm: FormGroup;

  // INPUTS
  inputs: IInputs = null;
  causas: number[] = [];
  arrayX: any[] = [];
  que: string = "";
  como: string = "";
  cuando: any = null;
  cuandoAux: any = null;
  donde: string = "";
  recursos: string = "";
  comentarios: string = "";
  isFulfilled: string;
  isEffective: string;
  seCumplio: boolean;
  esEficaz: boolean;
  ejecuta: number[] = [];
  evalua: number[] = [];
  causeAux: any = null;
  inputCauses: string[] = [];
  actionId: number = null;
  arrayChecks: ICheck[] = [];

  constructor(
    private localeService: BsLocaleService,
    private formBuilder: FormBuilder,
    private ngbModal: NgbModal,
    private translate: TranslateService,
    private globals: GlobalsService
  ) {}

  ngOnInit() {
    // console.log(this.action);
    // this.causesAux = this.causes;
    // console.log(this.causes);
    // console.log(this.translate.currentLang)
    this.cuando = new Date();
    this.minDate = new Date();
    // console.log(this.causes);
    this.localeService.use(this.translate.currentLang);
    this.datepickerConfig = {
      showWeekNumbers: false,
      dateInputFormat:
        this.translate.currentLang === "en" ? "MM/DD/YYYY" : "DD/MM/YYYY",
    };

    this.causesAux = this.causes;
    if (!isUndefined(this.causesAux)) {
      this.causesAux = this.causes.filter(
        (x) => x.seleccionado == true
      );
      for (let i = 0; i < this.causesAux.length; i++) {
        this.arrayChecks.push({
          value: this.causesAux[i].id,
          checked: false,
        });
      }
    }
    // console.log(this.arrayChecks);

    // console.log(this.users);
    this.users.forEach((user) => {
      // console.log(user);
      this.tagUsers.push({
        display: user.name,
        value: user.id,
        readonly: this.readOnly,
      });
    });

    this.checkAction();
    this.pushInputs();
  }

  /**
   * @description Abre una modal con el análisis
   * @param content Contenido de la modal
   * @return void
   * @author Miguel Ramírez
   */
  openAnalysis(content: any): void {
    this.ngbModal.open(content, {
      centered: true,
      size: "lg",
    });
  }

  public capturecanvas() {}

  deleteFileEnc(data) {
    // console.log(data);
    this.change = false;

    const evidencias = this.evidenciasAccion;

    for (let i = 0; i < evidencias.length; i++) {
      if (evidencias[i].name == data.name) {
        this.evidenciasAccion.splice(i, 1);
        break;
      }
    }
  }

  changeRadio() {
    if (this.isFulfilled == "yes") {
      this.seCumplio = true;
    } else if (this.isFulfilled == "no") {
      this.seCumplio = false;
    }

    this.pushInputs();
  }

  changeEffective() {
    if (this.isEffective == "yes") {
      this.esEficaz = true;
    } else if (this.isEffective == "no") {
      this.esEficaz = false;
    }

    this.pushInputs();
  }

  addFileEnc(event) {
    this.change = false;
    console.log("files", event);
    if (event.target.files && event.target.files.length > 0) {
      for (const row of event.target.files) {
        this.changeFileBase64(row, 2);
      }
    }
  }

  changeFileBase64(file, type) {
    const reader: any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (type === 1) {
        this.evidenciasNC.push({
          id: null,
          name: file.name,
          base64: reader.result.split(",")[1],
        });
      } else {
        this.evidenciasAccion.push({
          id: null,
          name: file.name,
          base64: reader.result.split(",")[1],
        });
      }

      this.pushInputs();
    };
  }

  checkAction(): void {
    if (!isUndefined(this.action)) {
      // console.log(this.action);
      this.causas = this.action.causas.map((cause: any) => cause.id);
      this.que = this.action.que;
      this.como = this.action.como;
      this.cuando = new Date(this.action.cuando);
      this.cuandoAux = new Date(this.action.cuando);
      this.donde = this.action.donde;
      this.recursos = this.action.recursos;
      this.minDate = new Date(this.action.cuando);
      this.minDate.setDate(this.minDate.getDate() + 1);
      this.actionId = this.action.id;
      this.comentarios = this.action.comentarios;
      this.seCumplio = this.action.seCumplio;
      this.esEficaz = this.action.fueronEficaces;
      // console.log(this.cuando);
      this.planTitle = this.que;

      if (
        this.action.evidencias !== null &&
        this.action.evidencias.length > 0
      ) {
        console.log("evidencias", this.action.evidencias);

        this.evidenciasAccion = this.action.evidencias.map((evidencia) => ({
          id: evidencia.id,
          name: evidencia.descripcion,
          base64: null,
          fileUrl: evidencia.file_url,
        }));
      }

      if (!this.readOnly) {
        for (let i = 0; i < this.causas.length; i++) {
          this.changeChecked(this.causas[i].toString(), true);
        }
      }

      if (this.seCumplio) {
        this.isFulfilled = "yes";
      } else if (this.seCumplio == false) {
        this.isFulfilled = "no";
      } else {
        this.isFulfilled = null;
      }

      if (this.esEficaz) {
        this.isEffective = "yes";
      } else if (this.esEficaz == false) {
        this.isEffective = "no";
      } else {
        this.isEffective = null;
      }

      // Ciclo para usuarios que evaluan
      for (let i = 0; i < this.action.usuariosEvaluan.length; i++) {
        for (let j = 0; j < this.tagUsers.length; j++) {
          if (
            +this.action.usuariosEvaluan[i].usuario.id ===
            +this.tagUsers[j].value
          ) {
            // this.tagUsersEvaluates.push(this.tagUsers[j]);
            this.addUserEvaluate(this.tagUsers[j]);
          }
        }
      }

      // Ciclo para usuarios que ejecutan
      for (let i = 0; i < this.action.usuariosEjecutan.length; i++) {
        for (let j = 0; j < this.tagUsers.length; j++) {
          if (
            +this.action.usuariosEjecutan[i].usuario.id ===
            +this.tagUsers[j].value
          ) {
            // this.tagUsersExecute.push(this.tagUsers[j]);
            this.addUserExecute(this.tagUsers[j]);
          }
        }
      }

      // console.log(this.tagUsersExecute);
      // console.log(this.tagUsersEvaluates);

      // Ciclo para las causas
      for (let i = 0; i < this.action.causas.length; i++) {
        this.arrayX.push({});
        this.inputCauses.push(this.action.causas[i].descripcion);
      }

      // console.log(this.tagUsersExecute, this.tagUsersEvaluates, this.tagUsers);
      this.pushInputs();
    } else {
      // console.log(this.defaultUserExecute);
      // console.log(this.defaultUserVerify);

      /* Agrega el usuario por default que evalue agregado en la fase 1 a los usuario que evaluan */
      if (this.defaultUserVerify !== null) {
        this.tagUsers.forEach((user) => {
          if (user.value === this.defaultUserVerify.id) {
            // this.tagUsersEvaluates.push(user);
            this.addUserEvaluate(user);
          }
        });
      }

      /* Agrega el usuario por default que ejecuta agregado en la fase 1 a los usuario que ejecutan */
      if (this.defaultUserExecute !== null) {
        this.tagUsers.forEach((user) => {
          if (user.value === this.defaultUserExecute.id) {
            // this.tagUsersExecute.push(user);
            this.addUserExecute(user);
          }
        });
      }
    }
    this.minDate = new Date();
  }

  /**
   * @description Cambia el formato de la fecha
   * @param date Fecha que s ele va a cambiar el formato
   * @return DD-MM-yyyy - string
   */
  formatDate(date, moreDay?: boolean, isSet?: boolean) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    // console.log(date);
    // console.log(d);

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    if (isSet) {
      if (this.action) {
        // console.log([year, day, month].join('-'));
        return [year, month, day].join("-");
      } else {
        // console.log([year, month, day].join('-'));
        return [year, month, day].join("-");
      }
    }

    // console.log([day, month, year].join('-'));
    return [day, month, year].join("/");
  }

  /**
   * @description Manda a eliminar al plan de acción
   * @return void
   * @author Miguel Ramírez
   */
  deleteAction(): void {
    this.deleteActionPlan.emit(this.index.toString());
    // console.log(this.causas);
    for (let i = 0; i < this.causas.length; i++) {
      this.addCause.emit(this.causas[i].toString());
    }
  }

  /**
   * @description Agrega un usuario que evalua
   * @param event Evento de onAdd, trae el nombre del usuario y el id
   * @return void
   * @author Miguel Ramírez
   */
  addUserEvaluate(event: IExecuteAndEvaluates): void {
    // console.log(event);
    if (this.evalua.length <= 1) {
      this.evalua.push(event.value);
      this.tagUsersEvaluates.push(event);
      // console.log(this.evalua);
      this.pushInputs();
    }
  }

  /**
   * @description Cambia el estado del check
   * @param causeId Id de la causa
   * @param isChecked TRUE: checkeado; FALSE: No checkeado
   * @return void
   * @author Miguel Ramírez
   */
  changeChecked(causeId: string, isChecked: boolean): void {
    for (let i = 0; i < this.arrayChecks.length; i++) {
      if (causeId == this.arrayChecks[i].value.toString()) {
        this.arrayChecks[i] = {
          ...this.arrayChecks[i],
          checked: isChecked,
        };
      }
    }
  }

  /**
   * @description Remueve un usuario que evalua
   * @param event Evento de onAdd, trae el nombre del usuario y el id
   * @return void
   * @author Miguel Ramírez
   */
  removeUserEvaluate(event: IExecuteAndEvaluates): void {
    for (let i = 0; i < this.evalua.length; i++) {
      if (this.evalua[i] == event.value) {
        this.evalua.splice(i, 1);
        this.tagUsersEvaluates.splice(i, 1);
        break;
      }
    }
    console.log(this.evalua);
    this.pushInputs();
  }

  /**
   * @description Agrega un usuario que ejecuta
   * @param event Evento de onAdd, trae el nombre del usuario y el id
   * @return void
   * @author Miguel Ramírez
   */
  addUserExecute(event: IExecuteAndEvaluates): void {
    // console.log(event);
    if (this.ejecuta.length <= 1) {
      this.ejecuta.push(event.value);
      this.tagUsersExecute.push(event);
      this.pushInputs();
    }
  }

  /**
   * @description Remueve un usuario que ejecuta
   * @param event Evento de onAdd, trae el nombre del usuario y el id
   * @return void
   * @author Miguel Ramírez
   */
  removeUserExecute(event: IExecuteAndEvaluates): void {
    for (let i = 0; i < this.ejecuta.length; i++) {
      if (this.ejecuta[i] == event.value) {
        this.ejecuta.splice(i, 1);
        this.tagUsersExecute.splice(i, 1);
        break;
      }
    }

    this.pushInputs();
  }

  /**
   * @description Cambia el estado del check
   * @param event
   */
  changeCheck(event: any) {
    // console.log(event);
    if (event.target.checked) {
      this.causeAux = parseInt(event.target.value);
      this.setCause(event.target.value);
      this.changeChecked(event.target.value, true);
    } else {
      for (let i = 0; i < this.causas.length; i++) {
        if (this.causas[i] == event.target.value) {
          this.deleteCausa(i);
          this.changeChecked(event.target.value, false);
          break;
        }
      }
    }
  }

  /**
   * @description Abre una modal
   * @param content Id o nombre de la modal que se va a abrir
   * @return void
   * @author Miguel Ramírez
   */
  openCausesModal(content: any): void {
    this.ngbModal.open(content, { centered: true });
  }

  /**
   * @description Cierra la modal
   * @return void
   * @author Miguel Ramírez
   */
  closeModal(): void {
    this.ngbModal.dismissAll();
    this.causeAux = null;
  }

  /**
   * @description Llena el formulario de inputs
   * @return void
   * @author Miguel Ramírez
   */
  pushInputs(event?: any): void {
    // console.log(this.cuando, this.cuandoAux);

    if (!isUndefined(event)) {
      if (this.que != "") {
        this.planTitle = event.target.value;
      } else {
        this.planTitle = undefined;
      }
    }

    this.inputs = {
      causas: this.causas,
      que: this.que,
      como: this.como,
      cuando: this.formatDate(this.cuando, false, true),
      donde: this.donde,
      recursos: this.recursos,
      ejecuta: this.ejecuta,
      evalua: this.evalua,
      id: this.actionId,
      comentarios: this.comentarios,
      seCumplio: this.seCumplio,
      evidencias: this.evidenciasAccion,
      fueronEficaces: this.esEficaz,
    };

    console.log({ INDX: this.index });

    // console.log(this.index);

    // Convertimos el JSON a string para pasarlo al evento
    this.changeInputs.emit(
      JSON.stringify({
        index: this.index,
        inputs: this.inputs,
        name: this.planTitle
          ? this.planTitle
          : this.translate.instant("formTreatment.planTitle", {
              i: this.title_number,
            }),
      } as IEventResponse)
    );

    // console.log(this.inputs);
  }

  changeDate() {
    setTimeout(() => {
      this.pushInputs();
    }, 100);
  }

  /**
   * @description Elimina una causa
   * @param index Posición donde se encuentra la causa que se va a eliminar
   * @return void
   * @author Miguel Ramírez
   */
  deleteCausa(index: number): void {
    this.changeChecked(this.causas[index].toString(), false);
    this.arrayX.splice(index, 1);
    this.causas.splice(index, 1);
    this.inputCauses.splice(index, 1);
    this.pushInputs();
  }

  /**
   * @description Agrega otra causa
   * @return void
   * @author Miguel Ramírez
   */
  addCausa(): void {
    this.arrayX.push({});
    this.causas.push(null);
    this.inputCauses.push("");
    // console.log(this.causas);
  }

  /**
   * @description Setea un valor al input de causa
   * @return void
   * @author Miguel Ramírez
   */
  setCause(causeId?: string): void {
    // console.log(this.causeAux);

    this.addCausa();
    this.causas[this.causas.length - 1] = this.causeAux;
    for (let i = 0; i < this.causes.length; i++) {
      if (this.causes[i].id == causeId) {
        // console.log(this.causes[i]);
        this.inputCauses[this.inputCauses.length - 1] = this.causes[
          i
        ].descripcion;
        break;
      }
    }
    this.causeAux = null;
    this.pushInputs();
  }
  b64ToBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  openFile(file) {
    console.log(file);
    let data = this.globals.apiUrl + file.fileUrl;
    saveAs(data, file.name);

    // const blob=this.b64ToBlob(file.base64)
    // const blobUrl=URL.createObjectURL(blob)

    //   window.open(blobUrl);
  }
}

export interface ICheck {
  value: number;
  checked: boolean;
}

export interface IInputs {
  causas: number[];
  que: string;
  como: string;
  cuando: string;
  donde: string;
  recursos: string;
  ejecuta: number[];
  evalua: number[];
  id: number;
  comentarios?: string;
  seCumplio?: boolean;
  evidencias?: any[];
  fueronEficaces?: boolean;
}

export interface IEventResponse {
  index: number;
  inputs: IInputs;
  name: string;
}

interface IExecuteAndEvaluates {
  display: string;
  value: number;
}
